<template> 	
  	<li @click="del" class="list-group-item">
  		[ 第{{index+1}}项 ]:

  		<span style="font-size:20px;font-weight: bolder;">“{{content}}”</span>
  		
 		  <span class="text-right" style="font-size:12px;color: #ccc;">创建于{{now}}</span>
 				
  	</li>
</template>

<script>
	if(localStorage.getItem('todolist')===''){
				localStorage.setItem('todolist','HelloWorld');
			}
export default {
	data(){
		return {
			now:new Date().toLocaleDateString()+ ' '+ new Date().toLocaleTimeString()
		}
	},
	props:['content','index'],
	methods:{
		del:function(){
			this.$emit('delete',[this.index,this.content,this.now]);	
		}
	},
	computed:{
		
	},
	watch:{
		now:function(){
				var _now = new Date().toLocaleDateString()+ '    '+ new Date().toLocaleTimeString();
				this.now = _now;
			}
		}

	}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	li{margin:0;padding: 0;}

	.list-group-item{margin-top:15px;border: none;}
</style>



// WEBPACK FOOTER //
// src/components/todoitem.vue